<ng-container *ngIf="content">
    <div bsModal #modal="bs-modal" class="modal-content custom-modal" style="width: 60vw; border: none">
        <div class="modal-header bg-info" style="width: 100%;">
            <h4 class="modal-title">{{CB.title | localize:{frameworkName: content.framework.title, 'no-cache':true} | async}}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCancel()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" *ngIf="content">
            <textarea [(ngModel)]="importData" class="form-control"></textarea>
        </div>
        <div class="modal-footer border-0">
            <button type="button" class="btn btn-light" (click)="onCancel()">{{CB.cancel | localize | async}}</button>
            <button type="button" class="btn btn-primary" [disabled]="importData == ''" (click)="onImportClick()">{{CB.importButton | localize | async }}</button>
            <button type="button" class="btn btn-primary" (click)="onExportClick()">{{CB.exportButton | localize | async }}</button>
        </div>
    </div>
</ng-container>